import EventHelper from "../../../../common/network/helpers/event/EventHelper";
import { ODIN_EVENT_EDITION_STORAGE_KEY } from "../../../../common/constants";
import CountriesHelper from "../../../../common/network/helpers/countries/CountriesHelper";
import { getFilteredCountries } from "../../../entry/utils/utils";
import { useState } from "react";
import { EventEditionDetails } from "../../../../common/types";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useGetMercuryShows } from "../../../globalSettings/hooks/useGetMercuryShows";
import { useFetchBadgeOrders } from "../../../entry/hooks/useFetchBadgeOrders/useFetchBadgeOrders";
import EventsHelper from "../../../../common/badges/events/EventsHelper";
import ApprovedBlockedService from "../../../../common/approvedBlockedService/ApprovedBlockedHelper";
import { setEventEdition as setEventEditionToStore } from "../../../../redux/eventEdition/slice/eventEditionSlice";
import { setAustraliaRegions, setCountryList, setIndiaRegions, setUsaRegions } from "../../../../redux/country/slice/countrySlice";

export const useEventConfiguration = () => {
  const dispatch = useDispatch();
  const [eventEdition, setEventEdition] = useState<EventEditionDetails>();
  const { getMercuryShows, loading, options } = useGetMercuryShows();
  const [error, setError] = useState<string>();
  const { t, i18n } = useTranslation("common");
  const { fetchBadgeOrdersForShows, startOrderFetchIntervalForShows } = useFetchBadgeOrders();

  const fetchEventEdition = async (eeId: string) => {
    try {
      const eventEditionInfo = await EventHelper.fetchEventEdition(eeId);

      localStorage.setItem(ODIN_EVENT_EDITION_STORAGE_KEY, eventEditionInfo.id);
      dispatch(setEventEditionToStore(eventEditionInfo));
      setEventEdition(eventEditionInfo);
      EventHelper.eventEdition = eventEditionInfo;
      await fetchBadgeOrdersForShows([eventEditionInfo.gbsCode]);
      await EventsHelper.fetchMercuryEvents();
      startOrderFetchIntervalForShows([eventEditionInfo.gbsCode]);
      await ApprovedBlockedService.initializeList(eventEditionInfo.gbsCode);
    } catch (e) {
      setError((e as Error).message ?? t("errors.clientError"));
      localStorage.removeItem(ODIN_EVENT_EDITION_STORAGE_KEY);
    }
  };

  const fetchCounties = async () => {
    try {
      const { countries, usaRegions, indiaRegions, australiaRegions } = await CountriesHelper.fetchCountriesWithMandatoryRegions(
        i18n.language
      );
      dispatch(setCountryList(getFilteredCountries(countries)));
      dispatch(setUsaRegions(usaRegions));
      dispatch(setIndiaRegions(indiaRegions));
      dispatch(setAustraliaRegions(australiaRegions));
    } catch (e) {
      setError((e as Error)?.message ?? t("errors.clientError"));
    }
  };

  return { error, setError, eventEdition, loading, options, fetchEventEdition, fetchCounties, getMercuryShows };
};
